// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--fgvNQ","icon":"a10a3f92e9--icon--a174v","description":"a10a3f92e9--description--vEDg9","title":"a10a3f92e9--title--R4tvU"};